// @ts-nocheck
import React, { Component } from 'react';
import { inject, observer } from "../../../../stores/mobx-compat";
import qs from 'query-string';
import { withRouter } from '../../../../router-compat';
import configs from '../configs';
import { IntegrationLayout, OAuthSetup, ExternalLinkA } from '../_shared';

class Pipedrive extends Component {
  componentDidMount() {
    this.props.store.integrations.Pipedrive.getConfigs();
    const { code } = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    if (code) this.props.store.integrations.Pipedrive.getTokens(code);
  }

  render() {
    return (
      <IntegrationLayout config={configs.Pipedrive}>
        <OAuthSetup
          partnerKey="Pipedrive"
          steps={[
            <>Create a Pipedrive account <ExternalLinkA href="https://app.pipedrive.com/signup-v2/marketing/step/join-pipedrive-account">here</ExternalLinkA> if you don&apos;t have one already.</>,
            'Grant Movology the necessary permissions:',
            'After authorizing, future captures will be added as Pipedrive contacts.',
          ]}
        />
      </IntegrationLayout>
    );
  }
}

export default withRouter(inject('store')(observer(Pipedrive)));
